module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_4.072076e2.jpg";